// removed by extract-text-webpack-plugin
module.exports = {"categoriesContainer":"categoriesContainer__15cCH"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/categorySlider/style.css
// module id = vMqS
// module chunks = 323